export default {"src":"/_next/static/media/facebook.7e72290d.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};